import React from 'react'
import {TimeStream} from '../utils';


export default class Timestamp extends React.PureComponent{
	render(){
		return <span>{TimeStream(this.props.timestamp)}</span>
	}
}



// WEBPACK FOOTER //
// ./src/components/Timestamp.js